import { api } from "./api";

const DEFAULT_BRANDING = {
  bedrijfsnaam: "QDB AI SYSTEEM",
  bedrijfsondertitel: "Festival POS systeem",
  logo_url: "",
  hoofdkleur: "#0E8F2A",
  accentkleur: "#F4C400",
  thema: "licht",
  bonnen_uit: false,
};

let _branding = DEFAULT_BRANDING;
const listeners = new Set();

export function getBranding() {
  return _branding;
}

export function subscribeBranding(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function loadBranding() {
  try {
    const { data } = await api.get("/branding");
    _branding = { ...DEFAULT_BRANDING, ...data };
  } catch {
    _branding = DEFAULT_BRANDING;
  }
  applyBranding(_branding);
  listeners.forEach((fn) => fn(_branding));
  return _branding;
}

export async function saveBranding(patch) {
  const { data } = await api.put("/branding", patch);
  _branding = { ...DEFAULT_BRANDING, ...data };
  applyBranding(_branding);
  listeners.forEach((fn) => fn(_branding));
  return _branding;
}

function applyBranding(b) {
  const root = document.documentElement;
  root.style.setProperty("--brand-green", b.hoofdkleur);
  root.style.setProperty("--brand-yellow", b.accentkleur);
  root.style.setProperty("--success", b.hoofdkleur);
  root.setAttribute("data-theme", b.thema || "licht");
  document.title = `${b.bedrijfsnaam} · Kassasysteem`;
}
